module.exports = __webpack_public_path__ + "static/media/44@2x.95b97ac6.png";